<div class="h-full flex flex-col relative">
  <div class="modal-header">
    <div class="flex items-center cursor-pointer">
      <span *ngIf="canDelete" nz-icon nzType="delete" class="p-1 pr-2" style="font-size: 18px; color:#fff"
        (click)="openDeleteModal()"></span>
      <svg-icon class="p-1" [size]="24" name="arrow-down" [fill]="'#fff'" (click)="downloadAttachment()"></svg-icon>
    </div>
    <div class="text-lg font-bold cursor-pointer"></div>
    <svg-icon name="times" [fill]="'#fff'" [size]="24" (click)="closeModal({ message: 'close' })"></svg-icon>
  </div>
  <div #background class="modal-content" (click)="checkClick($event)">
    <img *ngIf="attachment.thumbnail" nz-image [nzSrc]="photo" [nzPlaceholder]="thumbnail" [nzDisablePreview]="true"
      ngClass="{{isPortrait ? 'h-full' : 'landscape-img'}}" />
    <svg-icon *ngIf="!attachment.thumbnail" size="80" name="folder"></svg-icon>
  </div>
  <div class="modal-footer" style="flex: 1">
    <j-user [user]="userQuery.getEntity(attachment.createdBy)" [bold]="true"></j-user>
    <b>{{ attachment.createdAt | date:"short" }}</b>
  </div>
</div>
